import {addError, clearError} from './errorActions'
import {Constants} from './errorConstants'

type Actions =
    | ReturnType<typeof addError>
    | ReturnType<typeof clearError>

export function errorReducer(
	state: any[] = [],
	action: Actions
) {
	switch (action.type) {
	case Constants.ADD_ERROR:
		return state.concat(action.payload)

	case Constants.CLEAR_ERROR:
		return []

	}
	return state
}

